import { fetchBrandFromUrl } from './queryParams';

function getThemeName() {
  let brand = fetchBrandFromUrl();
  // check if brand name is valid, else send medicareCompared
  return brand;
}

export default getThemeName;
